import { render, staticRenderFns } from "./RewardCalcPage.vue?vue&type=template&id=77a5e610&scoped=true"
import script from "./RewardCalcPage.vue?vue&type=script&lang=js"
export * from "./RewardCalcPage.vue?vue&type=script&lang=js"
import style0 from "./RewardCalcPage.vue?vue&type=style&index=0&id=77a5e610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a5e610",
  null
  
)

export default component.exports